/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
import React, {useEffect, useState} from 'react'
import {PopoverText} from '../Popover/Popover'
import {useTranslation, initReactI18next} from 'react-i18next'
import {TOrder} from '../../redux/types'
import i18next from 'i18next'

interface BodyProps {
  data?: any
  type?: 'sip' | 'kontrak' | 'so'
}

export const Body: React.FC<BodyProps> = (props) => {
  const {t} = useTranslation()
  const [salesOption, setSalesOption] = useState(false)
  const [shipTol, setShipTol] = useState(false)

  const htmlString = props.data.lainlain

  useEffect(() => {
    if (props.type != 'kontrak') return
    const salesOpt = props.data.subItem.find((data: any) => data.at_sales_option?.length > 0)
    setSalesOption(salesOpt)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const createMarkup = () => {
    return {__html: htmlString}
  }

  const totalHarga = (include: boolean) => {
    let total: any = 0
    props?.data?.subItem.map((item: any, index: any) => {
      if (
        item.is_formulated_price == true ||
        props?.data.payloadquantum[index] != 0 ||
        item.id == undefined
      ) {
        total += include ?
          (props?.data?.payloadquantum[index] *
            (props?.data?.payloadharga[index] +
              (props?.data?.payloadharga[index] / 100) * props?.data?.subItem[0].ppn) -
          ((props?.data?.payloadquantum[index] *
            (props?.data?.payloadharga[index] +
              (props?.data?.payloadharga[index] / 100) * props?.data?.subItem[0].ppn)) /
            ((props?.data?.subItem[0].ppn + 100) / 100) /
            100) *
            0) : (props?.data?.payloadquantum[index] *
            props?.data?.payloadharga[index])
      } else {
        total += include ? item.price_after_ppn : item.price_before_ppn
      }
    })
    return parseFloat(total)
  }

  const fungsiAfterPPN = (index: any, include = true) => {
    if(!include){
      return props?.data?.payloadquantum[index] * props?.data?.payloadharga[index]
    }
    return (
      props?.data?.payloadquantum[index] *
        (props?.data?.payloadharga[index] +
          (props?.data?.payloadharga[index] / 100) * props?.data?.subItem[0].ppn) -
      ((props?.data?.payloadquantum[index] *
        (props?.data?.payloadharga[index] +
          (props?.data?.payloadharga[index] / 100) * props?.data?.subItem[0].ppn)) /
        ((props?.data?.subItem[0].ppn + 100) / 100) /
        100) *
        0
    )
  }

  const paymentTypes1 = props.data?.paymentMethod?.map((item: any) => item.payment_type_1_desc)
  const paymentTypes2 = props.data?.paymentMethod?.map((item: any) => item.payment_type_2_desc)
  let paymentTypes = null
  if (paymentTypes2 !== null) {
    paymentTypes = paymentTypes1?.concat(paymentTypes2)
  } else paymentTypes = paymentTypes1
  const uniqueData: any[] = []

  paymentTypes?.forEach((item: any) => {
    if (!uniqueData?.includes(item)) {
      uniqueData?.push(item)
    }
  })
  let filterPayment = uniqueData.filter((item: any) => item !== null)

  let paymentType =
    filterPayment.length > 1
      ? filterPayment.slice(0, -1).join(', ') + ' & ' + filterPayment.slice(-1)
      : filterPayment

  const dateFrom = new Date(props.data.dateFrom).toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
  const dateTo = new Date(props.data.dateTo).toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })

  // So
  const totalQuantum = () => {
    let total = 0
    props?.data?.payloadQuantum.map((item: any) => {
      total += item?.kuantum
    })
    return total
  }

  function formatValue(value: any, sectorId?: number, isCurrency?: boolean) {
    const isExport = sectorId == 3 || (!sectorId && props.data?.sector == 3);
    const isEn = i18next.language == "en";
    const locale = isEn ? 'en-US' : 'id-ID'
    const symbol = isExport ? 'USD ' : 'IDR '
    return `${isCurrency ? symbol : ''}${new Intl.NumberFormat(locale).format(value as number)}`
  }

  function kantongseprator() {
    let kantong = 0
    let ton = 0
    let separate = 'Ton'
    props?.data?.subItem.forEach((item: any, index: any) => {
      if (item.product_type == '8105') kantong += props?.data?.payloadQuantum[index]?.kuantum
      else ton += props?.data?.payloadQuantum[index]?.kuantum

      separate = item.sector_id != 2 ? 'MT' : 'Ton'
    })
    if (kantong == 0) return `${formatValue(ton)} ${separate}`
    else return `${formatValue(ton)} ${separate} & ${formatValue(kantong)} EA`
  }

  useEffect(() => {
    if (props.type !== 'kontrak') return
    for (let sub of props.data.subItem) {
      if (sub.shipping_tolerance_contract > '0' || props.data.shippingTolerance > 0) {
        return setShipTol(!shipTol)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (props.type !== 'so') return
    for (let sub of props.data.subItem) {
      if (parseInt(sub.shipping_tolerance) > 0) {
        return setShipTol(true)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getIdEnValue = (pName: string, sector: any, pNameEn: string) => {
    return sector == 3 ? (pNameEn ?? pName) : pName;
  }

  return (
    <>
      {props.type == 'sip' ? (
        <>
          <table className='table'>
            <tr className='w-100'>
              <td className='text-letter fs-3 fw-bold' style={{width: '10%'}}>
                {t('NO')}
              </td>
              <td className='text-letter fs-3 fw-bold' style={{width: '25%'}}>
                {t('PRODUCT')}
              </td>
              <td className='text-letter fs-3 fw-bold' style={{width: '15%'}}>
                {t('SPESIFIKASI')}
              </td>
              <td className='text-letter fs-3 fw-bold' style={{width: '15%'}}>
                {t('INCOTERM')}
              </td>
              <td className='text-letter fs-3 fw-bold' style={{width: '20%'}}>
                {t('HARGAJUALPERUNIT')}{' '}
                {props.data.sector == 1
                  ? props.data.includePpn
                    ? '(Include PPN)'
                    : '(Exclude PPN)'
                  : ''}
              </td>
              <td className='text-letter fs-3 fw-bold' style={{width: '15%'}}>
                {t('TONASE')}
              </td>
            </tr>
            {props.data.subItem.map((item: any, index: number) => (
              <tr key={item?.id ?? index}>
                <td className='text-letter fs-3'>{index + 1}</td>
                <td className='text-letter fs-3'>{item.product_name}</td>
                <td
                  className='text-letter fs-3'
                  style={{whiteSpace: 'pre-line'}}
                  dangerouslySetInnerHTML={{
                    __html: item.product_spec,
                  }}
                ></td>
                <td className='text-letter fs-3'>
                  { item.incoterm1?.code }
                  { item.incoterm2 ? (' - ' + item.incoterm2?.code) : (
                    (item.incoterm2_id && item.incoterm2_id != '0') ? (' - ' + item.incoterm2_id) : ''
                  ) }
                  { " " + [item.city?.city_name, item.province?.region_name].filter((x) => x ).join(', ') }
                </td>
                <td className='text-letter fs-3'>
                  {item.is_formulated_price
                    ? 'Harga Formula'
                    : ( item.price_usd != "0" ? formatValue(item.price_usd, 3, true)
                      : formatValue(item.fixed_price, item.sector_id, true)
                    )}
                </td>
                <td className='text-letter fs-3'>
                  {formatValue(item.fixed_quantum, item.sector_id)} Ton
                  {item.shipping_tolerance && parseInt(item.shipping_tolerance) > 0 && (
                    <>
                      <br/>
                      <span>(+/- {item.shipping_tolerance}%)</span>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </table>

          <div className='mt-8'>
          { props.data.sectorName && <div className='d-flex align-items-center w-100'>
              <p style={{width: '17%'}}>Sektor</p>
              <p style={{width: '3%'}}>:</p>
              <p style={{width: '80%'}}>
                <span style={{
                  fontStyle: 'italic'
                }}>{ props.data.sectorName }</span>
              </p>
            </div> }
            { props.data.segments?.length > 0 && <div className='d-flex align-items-center w-100'>
              <p style={{width: '17%'}}>Segment</p>
              <p style={{width: '3%'}}>:</p>
              <p style={{width: '80%'}}>
                {
                  props.data?.segments?.join(" & ")
                }
              </p>
            </div> }
            <div className='d-flex align-items-center w-100'>
              <p style={{width: '17%'}}>Periode Kontrak</p>
              <p style={{width: '3%'}}>:</p>
              <p style={{width: '80%'}}>
                {dateFrom == 'Invalid Date' ? '' : dateFrom} -{' '}
                {dateTo == 'Invalid Date' ? '' : dateTo}
              </p>
            </div>
            <div className='d-flex align-items-center w-100 mt-2'>
              <p style={{width: '17%'}}>Tipe Pembayaran</p>
              <p style={{width: '3%'}}>:</p>
              <p style={{width: '80%'}}>
                {/* {paymentType} {props.data.paymentInfo ? '-' + props.data.paymentInfo : ''} */}
                {props.data?.tipePembayaranSIP || '-'}
              </p>
            </div>
            <div className='d-flex w-100 mt-2'>
              <p style={{width: '17%'}}>Lain-lain</p>
              <p style={{width: '3%'}}>:</p>
              <p style={{width: '80%'}}>
                <div dangerouslySetInnerHTML={createMarkup()} />
              </p>
            </div>
          </div>
        </>
      ) : props.type == 'kontrak' ? (
        <>
          <table className='table'>
            <tr className='w-100'>
              <td className='text-letter fs-3 fw-bold'>{t('PRODUCT')}</td>
              <td className='text-letter fs-3 fw-bold'>{t('SPESIFIKASI')}</td>
              <td className='text-letter fs-3 fw-bold'>{t('KUANTITAS')}</td>
              {shipTol && <td className='text-letter fs-3 fw-bold'>{t('TOLERANSI_PENGIRIMAN')}</td>}
              {salesOption && <td className='text-letter fs-3 fw-bold'>{t('notes')}</td>}
              <td className='text-letter fs-3 fw-bold'>{t('INCOTERM')}</td>
              <td className='text-letter fs-3 fw-bold'>{t('HARGAJUALPERUNIT')}</td>
              <td className='text-letter fs-3 fw-bold'>{t('NILAI')}</td>
            </tr>
            {props.data.subItem.map((item: any, index: number) => (
              <tr key={item?.id ?? index}>
                <td className='text-letter fs-3'>{
                  getIdEnValue(
                    item.product_name,
                    item.sector_id,
                    item.material_desc_en
                  )
                }</td>
                <td
                  className='fs-3 px-3'
                  style={{whiteSpace: 'pre-line'}}
                  dangerouslySetInnerHTML={{
                    __html: props?.data?.payloadspec[index] || item?.product_spec,
                  }}
                ></td>
                <td className='text-letter fs-3'>
                  {formatValue(props?.data?.payloadquantum[index])}{' '}
                  {item?.product_type_desc == 'KANTONG/SACK'
                    ? item?.unit
                    : item.sector_id === 3
                    ? 'MT'
                    : 'Ton'}{' '}
                </td>
                {shipTol && (
                  <td className='text-letter fs-3'>
                    {item.shipping_tolerance_contract == 0
                      ? ''
                      : '±' + item.shipping_tolerance_contract + '%'}
                  </td>
                )}
                {salesOption && <td className='text-letter fs-3'>{item.at_sales_option}</td>}
                <td className='text-letter fs-3'>
                  {/* {item.incoterm1?.code} {item.incoterm2 ? ' - ' + item.incoterm2?.code : ''} */}
                  {
                    [
                      props.data.incoterm1 || item.incoterm1?.code,
                      props.data.incoterm2 || item.incoterm2?.code || ((item.incoterm2_id && item.incoterm2_id != 0) ? item.incoterm2_id : '')
                    ].filter((x) => x).join(" - ")
                  }
                </td>
                <td className='text-letter fs-3'>
                  <div className='d-flex justify-content-between'>
                  <span style={{
                  width: '50px'
                }}>
                    {item.sector_id != 3 ? 'IDR ' : 'USD '} 
                  </span>
                  <span>
                  {
                    formatValue(
                      (item.is_formulated_price == true || props?.data?.payloadquantum[index] != 0
                        ? fungsiAfterPPN(index, props.data?.include)
                        : (props.data?.include ? item.price_after_ppn : item.price_before_ppn)) / props?.data?.payloadquantum[index])}
                  </span>
                    </div>
                </td>
                <td className='text-letter fs-3'>
                <div className='d-flex justify-content-between'>
                <span style={{
                  width: '50px'
                }}>
                  {item.sector_id != 3 ? 'IDR ' : 'USD '}
                </span>
                <span>
                  {formatValue(item.is_formulated_price == true || props?.data?.payloadquantum[index] != 0
                    ? fungsiAfterPPN(index, props.data?.include)
                    : (props.data?.include ? item.price_after_ppn : item.price_before_ppn))}
                </span>
                </div>
                </td>
              </tr>
            ))}
            {
              (![0,'0','',null, undefined].includes(props?.data?.pph22)) && <tr>
              <td className='borderNone'></td>
              <td className='borderNone'></td>
              <td className='borderNone'></td>
              {shipTol && <td className='borderNone'></td>}
              {salesOption && <td className='borderNone'></td>}
              <td className='borderNone'></td>
              <td className='text-letter fs-3'>
                <b>PPH22</b>
              </td>
              <td className='text-letter fs-3' style={{whiteSpace: 'nowrap'}}>
                <div className='d-flex justify-content-between font-weight-bold'>
                <span style={{
                  width: '50px'
                }}>
                {props?.data?.sector != 3 ? 'IDR ' : 'USD '}
                </span>
                <span>
                   {formatValue(props?.data?.pph22)}
                </span>
                </div>
              </td>
            </tr>
            }
            <tr>
              <td className='borderNone'></td>
              <td className='borderNone'></td>
              <td className='borderNone'></td>
              {shipTol && <td className='borderNone'></td>}
              {salesOption && <td className='borderNone'></td>}
              <td className='borderNone'></td>
              <td className='text-letter fs-3'>
                <b>Total</b>
              </td>
              <td className='text-letter fs-3' style={{whiteSpace: 'nowrap'}}>
                <div className='d-flex justify-content-between font-weight-bold'>
                <span style={{
                  width: '50px'
                }}>
                {props?.data?.sector != 3 ? 'IDR ' : 'USD '}
                </span>
                <span>
                   {formatValue(totalHarga(props.data?.include))}
                </span>
                </div>
              </td>
            </tr>
          </table>
        </>
      ) : props.type == 'so' ? (
        <>
          <table className='table'>
            <tr className='w-100'>
              <td className='text-letter fs-3 fw-bold'>{t('NO')}</td>
              <td className='text-letter fs-3 fw-bold'>{t('PRODUCT')}</td>
              <td className='text-letter fs-3 fw-bold'>{t('SPESIFIKASI')}</td>
              <td className='text-letter fs-3 fw-bold'>{t('KUANTITAS')}</td>
              {shipTol && <td className='text-letter fs-3 fw-bold'>{t('TOLERANSIPENGIRIMAN')}</td>}
              <td className='text-letter fs-3 fw-bold'>{t('INCOTERM')}</td>
              <td className='text-letter fs-3 fw-bold'>{t('GUDANG')}</td>
            </tr>
            {props.data.sotype == 'create' ? (
              <>
                {props.data.subItem.map((item: any, index: number) => (
                  <tr key={item?.id ?? index}>
                    <td className='text-letter fs-3'>{index + 1}</td>
                    <td className='text-letter fs-3'>{
                      getIdEnValue(
                        item.product_name,
                        item.order_sub_detail?.sector_id,
                        item.order_sub_detail?.material_desc_en
                      )
                    }</td>
                    <td
                      className='text-letter fs-3 text-letter-left'
                      style={{
                        minWidth: 200,
                        whiteSpace: 'pre-line'
                      }}
                      dangerouslySetInnerHTML={{
                        __html: props.data?.payloadSpec[index],
                      }}
                    ></td>
                    <td className='text-letter fs-3'>
                      {formatValue(props.data?.payloadQuantum[index]?.kuantum)}{' '}
                      {item.product_type == '8105' ? item.unit : 
                      (item.sector_id != 2 ? 'MT' : 'Ton')
                      }
                    </td>
                    {shipTol && (
                      <td className='text-letter fs-3'>
                        {props.data.shippingTolerance_so[index].shipping_tolerance_so > 0
                          ? '±' + props.data.shippingTolerance_so[index].shipping_tolerance_so + '%'
                          : ''}
                      </td>
                    )}
                    <td className='text-letter fs-3'>
                      {
                        [
                          props.data?.incoterm1 || item.incoterm1?.code,
                          props.data?.incoterm2 || item.incoterm2?.code || (item.incoterm2_id && item.incoterm2_id != "0" ? item.incoterm2_id : null)
                        ].filter((x) => x).join(" - ")
                      }
                    </td>
                    <td className='text-letter fs-3'>{
                      getIdEnValue(
                        props.data?.payloadPlantEn[index],
                        item.order_sub_detail?.sector_id,
                        props.data?.payloadPlant[index]
                      )
                    }</td>
                  </tr>
                ))}
              </>
            ) : (
              <>
                {props.data.subItem.map((item: any, index: number) => (
                  <tr key={item?.id ?? index}>
                    <td className='text-letter fs-3'>{index + 1}</td>
                    <td className='text-letter fs-3'>{
                      getIdEnValue(
                        item.product_name,
                        item.order_sub_detail?.sector_id,
                        item.order_sub_detail?.material_desc_en
                      )
                    }</td>
                    <td
                      className='text-letter fs-3 text-letter-left'
                      style={{whiteSpace: 'pre-line'}}
                      dangerouslySetInnerHTML={{
                        __html: item.product_spec,
                      }}
                    ></td>
                    <td className='text-letter fs-3'>
                      {formatValue(props.data?.payloadQuantum[index]?.kuantum)}{' '}
                      {item.product_type == '8105' ? item.unit : (item.sector_id != 2 ? 'MT' : 'Ton')}
                    </td>
                    {shipTol && (
                      <td className='text-letter fs-3'>{`±${
                        Number(item?.shipping_tolerance) ?? 0
                      }%`}</td>
                    )}
                    <td className='text-letter fs-3'>
                      {
                        [
                          item.incoterm1?.code,
                          item.incoterm2 ? item.incoterm2?.code : item.incoterm2_id
                        ].filter((x: any) => x).join(" - ")
                      }
                    </td>
                    <td className='text-letter fs-3'>{item.plant + " - " + getIdEnValue(
                        item.plant_desc,
                        item.order_sub_detail?.sector_id,
                        item.plant_desc_en,
                      )}</td>
                  </tr>
                ))}
              </>
            )}

            <tr>
              <td className='borderNone'></td>
              <td className='text-letter fs-3' colSpan={2}>
                <b>TOTAL</b>
              </td>
              <td className='text-letter fs-3'>
                <b>{kantongseprator()}</b>
              </td>
              <td className='borderNone'></td>
              <td className='borderNone'></td>
              <td className='borderNone'></td>
            </tr>
          </table>
        </>
      ) : (
        <></>
      )}
    </>
  )
}

export default React.memo(Body)
